// TradingViewWidget.jsx
import React, { useEffect, useRef, memo } from "react";

function TradingViewWidget({ ticker, exchange }) {
  const container = useRef();

  let chartSetting = localStorage.getItem("chart_settings");

  const defaultPrepories = {
    chartTheme: "light",
    chartType: "8",
    timeInterval: "D",
    show_top_toolbar: false,
    show_bottom_toolbar: false,
    showDrawingToolsBar: false,
    enable_publishing: false,
    hotlist: false,
    show_calender: false,
    show_volume: false,
    show_details: false,
  };

  if (!chartSetting) {
    localStorage.setItem("chart_settings", JSON.stringify(defaultPrepories));
  }

  const {
    chartTheme,
    chartType,
    timeInterval,
    show_top_toolbar,
    show_bottom_toolbar,
    showDrawingToolsBar,
    enable_publishing,
    hotlist,
    show_calender,
    show_volume,
    show_details,
  } = JSON.parse(chartSetting) ?? defaultPrepories;

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js";
    script.type = "text/javascript";
    script.async = true;
    script.innerHTML = `
        {
          "autosize": true,
          "symbol": "${exchange === "XNYS" ? "NYSE" : "NASDAQ"}:${ticker}",
          "interval": "${timeInterval}",
          "timezone": "Etc/UTC",
          "theme": "${chartTheme}",
          "locale": "en",
          "style": "${chartType}",
          "enable_publishing": ${enable_publishing} ,
          "allow_symbol_change": true,
          "details": true,
          ${showDrawingToolsBar ? '"hide_side_toolbar": false,' : ""}
          ${!show_top_toolbar ? '"hide_top_toolbar": true,' : ""}
          ${!show_bottom_toolbar ? '"withdateranges": true,' : ""}
          ${hotlist ? '"hotlist": true,' : ""}
          ${show_calender ? '"calendar": true,' : ""}
          ${!show_volume ? '"hide_volume": true,' : ""}
          ${show_details ? '"details": true,' : ""}
          "support_host": "https://www.tradingview.com"
        }`;
    container.current.appendChild(script);
  }, [ticker, exchange, timeInterval, chartTheme, chartType]);

  return (
    <div className="tradingview-widget-container" ref={container} style={{ height: "100%", width: "100%" }}>
      <div
        className="tradingview-widget-container__widget"
        style={{ height: "calc(100% - 32px)", width: "100%" }}
      ></div>
    </div>
  );
}

export default memo(TradingViewWidget);
